import { ResourceOptions } from 'react-admin';
import { FaTasks } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './list';
// users 模块仅提供列表

export const name = Resources.activityUsers;
export const icon = FaTasks;
export const options: ResourceOptions = {
  label: 'resource.activityUsers',
};
